module.exports = __webpack_public_path__ + "static/media/Battery Icon.f9d262cc.jpeg";